import styled from "styled-components/native";

export const StyledContainer = styled.View`
	height: 100%;
	width: 100%;
	background-color: #141414;
`;

export const StyledGridPackshots = styled.View<{ isShortClips: boolean; isNarrow?: boolean }>`
	margin-bottom: 3%;
	padding-top: ${(props) => (props.isNarrow ? "6rem" : "153px")};
	padding-bottom: ${(props) => (props.isShortClips ? "6rem" : 0)};
`;

export const StyledControllerContainer = styled.View`
	top: 80px;
`;

export const StyledControllerLoader = styled.View<any>`
	position: absolute;
	height: calc(100vh - 80px);
	width: 300px;
	top: 0;
	left: 0;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
`;

export const StyledLoaderFrame = styled.View<any>`
	margin-top: 20px;
	margin-left: ${(props) => (props.isToggleMQTT && props.isNarrow && props.isVam ? 250 : 0)}px;
`;
